export default {
    namespaced: true,
    hanwha_dvr: {
      title: "Gravador de Vídeo Hanwha | Gravador de vídeos Hanwha",
      name: "nome",
      ip: "IP",
      user: "Usuário | Usuários",
      password: "senha",
      http_schema: "esquema http(s)",
      rtsp_schema: "esquema rtsp(s)",
      http_port: "porta http",
      rtsp_port: "porta rtsp",
      disk_info: "Informações sobre o disco",
      network_info: "Informações sobre a rede",
      information: "Informações",
      details: "Detalhes",
      recording_days: "Dias de gravações",
      enabled_recording_audit: "Habilitar auditoria de gravação",
      days_recording_audit: "Dias de auditoria de gravação",
      model: "Modelo",
      firmware_version: "Versão do firmware",
      build_date: "Data de compilação",
      device_type: "Tipo de dispositivo",
      local_ip: "IP local",
      mac_address: "Endereço MAC",
      groups: "Grupos",
      groups_permissions: {
        export: {
          name: 'Exportar',
          channels: 'Canais'
        },
        general: {
          record: 'Gravações',
          stop_recording: 'Parar gravações',
          ptz_control: 'Controle PTZ',
          output_control: 'Controle remoto de saída de alarme',
          shutdown: 'Desligar'
        },
        menu: {
          camera: {
            name: 'Câmera',
            register: 'Registro',
            channel_setup: 'Configuração de canal',
            camera_setup: 'Configuração de câmera',
            camera_password: 'Senha da câmera'
          },
          device: {
            name: 'Dispositivo',
            storage_device: 'Dispositivo de Armazenamento',
            device_format: 'Formato do dispositivo',
            smart: 'S.M.A.R.T',
            monitor: 'Monitor',
            text: 'Texto',
            device: 'Dispositivo',
            event: 'Evento'
          },
          event: {
            name: 'Evento',
            nvr_sensor_detection: 'Detecção do sensor Nvr',
            event_setup: 'Configuração do evento',
            onvif_event: 'Evento ONVIF',
            event_rule: 'Regra de Evento',
            event_schedule: 'Programação de eventos'
          },
          network:{
            name: 'Rede',
            ip_port: 'IP e Porta',
            ip: 'IP',
            port: 'Porta',
            email: 'Email',
            smtp: 'SMTP',
            event: 'Evento',
            recipient: 'Destinatário',
            ddns: 'DDNS',
            ip_filtering: 'Filtragem de IP',
            https: 'HTTPS',
            8021: '801.1x' ,
            snmp: 'SNMP',
            dhcp: 'Servidor DHCP',
            p2p: 'P2P'
          },
          record: {
            name: 'Gravação',
            recording_schedule: 'Programação de gravação',
            record_setup: 'Configuração de gravação',
            record_option: 'Opção de gravação'
          },
          system: {
            name: 'Sistema',
            date_time_laguage: 'Data/Hora/Idioma',
            system_management: 'Gerenciamento do Sistema',
            product_information: 'Informações do produto',
            log: 'Log',
            system_log: 'Log do Sistema',
            event_log: 'Log de Eventos',
            export_log: 'Log de Exportação'
          }
        },
        select_all: 'selecionar todos',
        search_channel: {
          name: 'Buscar canal',
          channels: 'Canais'
        }
      },
      dateTimeLanguageConfig: 'Configurar data, hora e idioma',
      updateAdminUserPassword: 'Alterar senha de administrador',
      deviceInfo: 'Información del dispositivo',
      adminRecord: 'Administrar grabaciones',
      router: 'Roteador',
      networkConfig: 'Configuración de red',
      auditStartAt: 'Fecha de inicio de auditoría'
    },
};
